import yeatiLogo from "@/assets/images/yeati-logo.png";
import { EnhancedCard } from "@/features/card/types/card.type";
import { cn } from "@/shared/utils/style.util";

type PaymentCardVersoProps = { data: EnhancedCard };

export const PaymentCardVerso = ({ data }: PaymentCardVersoProps) => (
  <div className={cn(
    "font-mono text-base text-muted text-[0.5rem]",
    "relative flex flex-col justify-between w-full h-full pb-2 pt-1 rounded-md overflow-hidden shadow-lg",
    "border border-gray-300 bg-gradient-to-br from-gray-800 to-gray-900",
    "border-[#202020] border-t-[#444444]",
  )}
  >
    <div className="flex items-center px-6 space-x-2 text-muted">
      <span>yeati.co</span>
      <span>+33972 100 982</span>
    </div>

    <div className="bg-black/30 h-16 mt-1" />

    <div className="flex flex-col items-start space-y-1 pl-4">
      <div className="flex items-center gap-2 my-2">
        <div className="w-14 h-10 rounded-full bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 flex items-center justify-end shadow-lg">
          <div className="w-7 h-7 bg-white/20 rounded-full m-2" />
        </div>

        {/* Brand section */}
        <div className="flex flex-col items-start font-sans">
          <img
            src={yeatiLogo}
            alt="Yeati"
            className="h-6 w-auto"
          />
          <p className="flex gap-2 text-sm px-2 py-1 mx-[-8px] text-white border-2 border-red-500">
            Identifiant :
            <span className="tracking-[0.2em]">___ ___ ___</span>
          </p>
        </div>
      </div>

      <p className="text-sm">{data.formattedCardNumber}</p>

      <div className="flex items-center space-x-2">
        <span className="flex flex-col items-start space-x-1">
          <span>EXPIRE</span>
          <span>A FIN</span>
        </span>
        <span className="text-sm">{`${data.expireAt.month}/${data.expireAt.shortYear}`}</span>
      </div>
    </div>
  </div>
);
